import React from 'react';
import ThumbnailItem from './ThumbnaiItem';

interface CategoryBlockProps {
  allowThumbnails: boolean;
  title: string;
  items: [{ link?: { href: string; text: string }; thumbnailUrl: string }];
}

const CategoryBlock = ({
  allowThumbnails,
  items,
  title,
}: CategoryBlockProps) => {
  return (
    <div className="flex flex-col gap-4 md:gap-6">
      {title && <h1 className="uppercase">{title}</h1>}
      {items && (
        <div className="overflow-x-auto whitespace-nowrap scrollbar-none">
          <div className="lg:container flex w-full gap-4 lg:grid lg:grid-cols-3 lg:gap-6 2xl:grid-cols-6">
            {allowThumbnails
              ? items.map((item) => (
                  <ThumbnailItem
                    key={item.link?.text}
                    link={item.link}
                    img={item.thumbnailUrl}
                  />
                ))
              : items.map(
                  (item) =>
                    item.link?.href && (
                      <a
                        className="btn btn--large btn--secondary min-w-fit flex-1"
                        href={item.link.href}
                        key={item.link.text}
                      >
                        {item.link.text}
                      </a>
                    )
                )}
          </div>
        </div>
      )}
    </div>
  );
};

export default CategoryBlock;
